import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Button = styled.button<{ disabled?: boolean }>`
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  min-width: 120px;
  position: relative;
  
  &:hover {
    background-color: ${props => props.disabled ? '#3498db' : '#2980b9'};
  }
  
  &:active {
    transform: ${props => props.disabled ? 'none' : 'translateY(1px)'};
  }
  
  &:disabled {
    opacity: 0.7;
  }
`;

const ButtonLabel = styled.span<{ isLoading?: boolean }>`
  display: ${props => props.isLoading ? 'none' : 'inline'};
`;

const LoadingSpinner = styled.div<{ isLoading?: boolean }>`
  display: ${props => props.isLoading ? 'inline-block' : 'none'};
  width: 20px;
  height: 20px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

interface SubmitButtonProps {
  text: string;
  isLoading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  text,
  isLoading = false,
  disabled = false,
  onClick
}) => {
  return (
    <Button
      type="submit"
      disabled={disabled || isLoading}
      onClick={onClick}
    >
      <ButtonLabel isLoading={isLoading}>{text}</ButtonLabel>
      <LoadingSpinner isLoading={isLoading} />
    </Button>
  );
};

export default SubmitButton;